import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0671 = React.lazy(() => import('./symbols/0671_vector_bezier_curve_illustrator'));
const Symbol0672 = React.lazy(() => import('./symbols/0672_crop_image'));
const Symbol0673 = React.lazy(() => import('./symbols/0673_ruller_dimension_length'));
const Symbol0674 = React.lazy(() => import('./symbols/0674_cut_scissors'));
const Symbol0675 = React.lazy(() => import('./symbols/0675_paint_brush_color'));
const Symbol0676 = React.lazy(() => import('./symbols/0676_eyedropper_color'));
const Symbol0677 = React.lazy(() => import('./symbols/0677_color_wheel_rgb'));
const Symbol0678 = React.lazy(() => import('./symbols/0678_pen_writting_fontain'));
const Symbol0679 = React.lazy(() => import('./symbols/0679_paint_brush'));
const Symbol0680 = React.lazy(() => import('./symbols/0680_pencil_ruller_drawing'));
const Symbol0681 = React.lazy(() => import('./symbols/0681_drawing_board_canvas_table'));
const Symbol0682 = React.lazy(() => import('./symbols/0682_pencil'));
const Symbol0683 = React.lazy(() => import('./symbols/0683_pen'));
const Symbol0684 = React.lazy(() => import('./symbols/0684_paint_brush'));
const Symbol0685 = React.lazy(() => import('./symbols/0685_marker_text'));
const Symbol0686 = React.lazy(() => import('./symbols/0686_cut_knife'));
const Symbol0687 = React.lazy(() => import('./symbols/0687_pantone_color_guide_samples_book'));
const Symbol0688 = React.lazy(() => import('./symbols/0688_paint_bucket_color'));
const Symbol0689 = React.lazy(() => import('./symbols/0689_paint_bucket_color'));
const Symbol0690 = React.lazy(() => import('./symbols/0690_spray_color'));
const Symbol0691 = React.lazy(() => import('./symbols/0691_wall_paint_color'));
const Symbol0692 = React.lazy(() => import('./symbols/0692_paper_layers'));
const Symbol0693 = React.lazy(() => import('./symbols/0693_reflect_vertical'));
const Symbol0694 = React.lazy(() => import('./symbols/0694_reflect_horizontal'));
const Symbol0695 = React.lazy(() => import('./symbols/0695_pathfinder_shapes_minus_back'));
const Symbol0696 = React.lazy(() => import('./symbols/0696_pathfinder_shapes_unite'));
const Symbol0697 = React.lazy(() => import('./symbols/0697_pathfinder_shapes_exclude'));
const Symbol0698 = React.lazy(() => import('./symbols/0698_pathfinder_shapes_intersect'));

export interface IProps {}

const Drawing: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0671_vector_bezier_curve_illustrator" symbol={<Symbol0671 />} />
      <LazySymbol id="0672_crop_image" symbol={<Symbol0672 />} />
      <LazySymbol id="0673_ruller_dimension_length" symbol={<Symbol0673 />} />
      <LazySymbol id="0674_cut_scissors" symbol={<Symbol0674 />} />
      <LazySymbol id="0675_paint_brush_color" symbol={<Symbol0675 />} />
      <LazySymbol id="0676_eyedropper_color" symbol={<Symbol0676 />} />
      <LazySymbol id="0677_color_wheel_rgb" symbol={<Symbol0677 />} />
      <LazySymbol id="0678_pen_writting_fontain" symbol={<Symbol0678 />} />
      <LazySymbol id="0679_paint_brush" symbol={<Symbol0679 />} />
      <LazySymbol id="0680_pencil_ruller_drawing" symbol={<Symbol0680 />} />
      <LazySymbol id="0681_drawing_board_canvas_table" symbol={<Symbol0681 />} />
      <LazySymbol id="0682_pencil" symbol={<Symbol0682 />} />
      <LazySymbol id="0683_pen" symbol={<Symbol0683 />} />
      <LazySymbol id="0684_paint_brush" symbol={<Symbol0684 />} />
      <LazySymbol id="0685_marker_text" symbol={<Symbol0685 />} />
      <LazySymbol id="0686_cut_knife" symbol={<Symbol0686 />} />
      <LazySymbol id="0687_pantone_color_guide_samples_book" symbol={<Symbol0687 />} />
      <LazySymbol id="0688_paint_bucket_color" symbol={<Symbol0688 />} />
      <LazySymbol id="0689_paint_bucket_color" symbol={<Symbol0689 />} />
      <LazySymbol id="0690_spray_color" symbol={<Symbol0690 />} />
      <LazySymbol id="0691_wall_paint_color" symbol={<Symbol0691 />} />
      <LazySymbol id="0692_paper_layers" symbol={<Symbol0692 />} />
      <LazySymbol id="0693_reflect_vertical" symbol={<Symbol0693 />} />
      <LazySymbol id="0694_reflect_horizontal" symbol={<Symbol0694 />} />
      <LazySymbol id="0695_pathfinder_shapes_minus_back" symbol={<Symbol0695 />} />
      <LazySymbol id="0696_pathfinder_shapes_unite" symbol={<Symbol0696 />} />
      <LazySymbol id="0697_pathfinder_shapes_exclude" symbol={<Symbol0697 />} />
      <LazySymbol id="0698_pathfinder_shapes_intersect" symbol={<Symbol0698 />} />
    </>
  );
});

Drawing.displayName = 'Drawing';

export default Drawing;
